import { Container, Graphics, Sprite } from "@pixi/react";
import { Point, Resource, Texture } from "pixi.js";

export function DuplicateKnob({
  duplicateKnobPosition,
  knobIcon,
  placeScale,
  onTap
}: Readonly<{
  duplicateKnobPosition: Point;
  knobIcon: Texture<Resource> | undefined;
  placeScale: number;
  onTap: () => void;
}>) {
  return (
    <Container
      data-testid={"duplicate-knob-grap-container"}
      eventMode={"static"} // interactive
      onpointertap={e => {
        e.stopPropagation();
        onTap();
      }}
    >
      <Graphics
        cursor={"pointer"}
        data-testid={"duplicate-knob-grap"}
        draw={g => {
          g.clear();
          g.beginFill(0xffffff);
          g.drawCircle(duplicateKnobPosition.x, duplicateKnobPosition.y, 25 * placeScale);
          g.endFill();
        }}
      />
      <Sprite
        cursor={"pointer"}
        data-testid={"duplicate-knob-spr"}
        eventMode="passive"
        texture={knobIcon}
        position={{
          x: duplicateKnobPosition.x - 15 * placeScale,
          y: duplicateKnobPosition.y - 14 * placeScale
        }}
        width={30 * placeScale}
        height={30 * placeScale}
      />
    </Container>
  );
}
